import { DefaultSeoProps } from 'next-seo'

const config: DefaultSeoProps = {
  title: '의사의 노트',
  description: '의사의 설명을 환자 손안에',
  openGraph: {
    type: 'website',
    url: 'https://www.dnotes.icu/',
    siteName: '의사의 노트',
    description: '의사의 설명을 환자 손안에',
    images: [{ url: 'https://www.dnotes.icu/og-image.png', width: 2400, height: 1200 }],
  },
}

export default config
